import { render, staticRenderFns } from "./notSite.vue?vue&type=template&id=bb9a4aee&scoped=true"
import script from "./notSite.vue?vue&type=script&lang=js"
export * from "./notSite.vue?vue&type=script&lang=js"
import style0 from "./notSite.vue?vue&type=style&index=0&id=bb9a4aee&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bb9a4aee",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/data/jenkins/data/workspace/KCC_AUDIT_PROD_Frontend/node_modules/vue-loader/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('bb9a4aee')) {
      api.createRecord('bb9a4aee', component.options)
    } else {
      api.reload('bb9a4aee', component.options)
    }
    module.hot.accept("./notSite.vue?vue&type=template&id=bb9a4aee&scoped=true", function () {
      api.rerender('bb9a4aee', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/error/notSite.vue"
export default component.exports